import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    clear(event) {
        if (event.target.value === "0" || event.target.value === "0.0") {
            event.target.value = ""
        }
    }

    restore(event) {
        if (event.target.value === "") {
            event.target.value = "0.0"
        }
    }
}